import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'SERVERS',
    itemActionName: 'SERVER',
});
